import Http from 'axios'
import {
    VERSIONED_API_URL
} from '../../config/config'

function initialState() {
    return {
        groups: [],
        office_groups: []
    }
}

const getters = {
    groups: state => state.groups,
    loading: state => state.loading
};

const actions = {

    fetchData({commit}) {
        Http.get(`${VERSIONED_API_URL}/airport-terminal/groups`).then((response) => {
            commit('setGroups', response.data.data)
        });
    },
    async fetchGroupByOffice({commit}, office) {
        try {
            const {data} = await Http.get(`${VERSIONED_API_URL}/airport-terminal/groups`, {
                params: {
                    office
                }
            });
            commit('setOfficeGroups', data.data)
        } catch (e) {
            throw e;
        }
    },
    resetState({commit}) {
        commit('resetState')
    }
};

const mutations = {
    setLoading(state, loading) {
        state.loading = loading
    },
    setGroups(state, item) {
        state.groups = item
    },
    setOfficeGroups(state, item) {
        state.office_groups = item;
    }
};

export default {
    namespaced: true,
    state: initialState,
    getters,
    actions,
    mutations
}
